var map = {
	"./Alemanha.svg": 4486,
	"./Arabia_Saudita.svg": 8971,
	"./Argentina.svg": 8226,
	"./Australia.svg": 9433,
	"./Belgica.svg": 6052,
	"./Brasil.svg": 8262,
	"./Camaroes.svg": 6351,
	"./Canada.svg": 7928,
	"./Catar.svg": 4415,
	"./Coreia_do_Sul.svg": 646,
	"./Costa_Rica.svg": 8923,
	"./Croacia.svg": 6609,
	"./Dinamarca.svg": 74,
	"./Empty.svg": 6238,
	"./Equador.svg": 4267,
	"./Espanha.svg": 5139,
	"./Estados_Unidos.svg": 2158,
	"./Franca.svg": 3612,
	"./Gana.svg": 6341,
	"./Holanda.svg": 8472,
	"./Inglaterra.svg": 5660,
	"./Ira.svg": 5888,
	"./Japao.svg": 6818,
	"./Marrocos.svg": 8795,
	"./Mexico.svg": 5096,
	"./Pais_de_Gales.svg": 9665,
	"./Polonia.svg": 9850,
	"./Portugal.svg": 4487,
	"./Senegal.svg": 6855,
	"./Servia.svg": 3844,
	"./Suica.svg": 7447,
	"./Tunisia.svg": 5737,
	"./Uruguai.svg": 2317
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 236;